/**
 *
 * @param {Sprites} sprites
 * @returns {String[]}
 */
function toSpriteUrls(sprites) {
  return sprites.swatchSpriteUrls.map((url) => sprites.urlTemplate + url);
}

/**
 *
 * @param {Colors} [colors]
 * @returns {Color[]}
 */
function orderColorsById(colors) {
  const colorMap = colors?.colorMap || {};
  const colorIds = colors?.orderedColorsById || [];

  return colorIds.map((colorId) => colorMap[colorId]);
}

/**
 *
 * @param {Pricing} [priceToColors]
 * @returns {String}
 */
function getPriceRange(priceToColors) {
  const firstPrice = priceToColors?.[0]?.price;
  const lastPriceValue = priceToColors?.[priceToColors?.length - 1];
  const lastPrice = lastPriceValue?.price;

  return `${lastPrice}-${firstPrice}`;
}

/**
 *
 * @param {Product | undefined} product
 * @param {{isMcom: boolean}} options
 * @returns {ParsedColors}
 */
module.exports = function parser(product, { isMcom } = { isMcom: true }) {
  const colors = product?.traits.colors;
  let priceToColors = product?.traits.traitsMaps.priceToColors;

  // if colorway + percentage off promo auto apply final price -> update tier price
  if (priceToColors && !isMcom) {
    priceToColors.forEach((priceTier) => {
      const colorId = priceTier?.colorIds?.[0];
      const finalPrice = product?.traits?.colors?.colorMap?.[colorId]?.pricing?.price?.finalPrice;
      const finalPriceValue = finalPrice?.values?.[0]?.formattedValue;
      if (finalPriceValue && !finalPrice?.promoCode) {
        priceTier.price = finalPriceValue;
        priceTier.onSale = true;
      }
    });
  }

  const priceToColorsExp = [
    {
      colorIds: priceToColors?.flatMap((priceTier) => priceTier.colorIds) ?? [],
      onSale: priceToColors?.every((priceTier) => priceTier.onSale) ?? false,
      priceRange: (product?.pricing?.price?.tieredPrice && getPriceRange(priceToColors)) ?? '',
    },
  ];

  // There is no priceToColor data for master, consolidated products
  if (!priceToColors) {
    priceToColors = [{ colorIds: Object.keys(colors?.colorMap || {}).map((key) => Number(key)) }];
  }

  const sprites = {
    swatchSpriteUrls: (isMcom
      ? colors?.swatchSprite?.swatchSpriteUrls : colors?.largeSwatchSprite?.swatchSpriteUrls) || [],
    urlTemplate: product?.urlTemplate?.swatchSprite || '',
  };

  return {
    selectedColor: colors?.selectedColor ?? -1,
    colorMap: colors?.colorMap || {},
    colorArray: orderColorsById(colors),
    spriteUrls: toSpriteUrls(sprites),
    priceToColors,
    priceToColorsExp,
  };
};
